import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";

const Accordion = ({ props }) => {
  const { answer, question } = props;
  const [showAnswer, setShowAnswer] = useState(false);
  const answerDiv = useRef();

  const height = () => answerDiv?.current.scrollHeight;

  return (
    <div>
      <div
        className="flex items-center justify-between px-5 py-4 bg-white border border-gray-300 cursor-pointer select-none rounded-xl"
        onClick={() => setShowAnswer(!showAnswer)}
      >
        <div className="text-lg font-extrabold">{question}</div>
        <FontAwesomeIcon
          icon={faAngleDown}
          className={`text-[#00E09E] duration-200 text-lg ${
            showAnswer ? "rotate-180" : "rotate-0"
          }`}
        />
      </div>
      <div
        style={{ height: showAnswer ? height() : 0 }}
        ref={answerDiv}
        className={`px-3 mt-5 font-semibold duration-300 leading-loose ${
          showAnswer ? `opacity-100 visible mb-10` : "opacity-0 invisible"
        }`}
      >
        {answer}
      </div>
    </div>
  );
};

export default Accordion;
